import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
  numberAttribute,
} from '@angular/core';

@Component({
  selector: 'ds-col',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<ng-content />`,
  styles: [`
    :host {
      --ds-col-span-current: var(--ds-col-span, 12);
      --ds-col-start-current: auto;
      display: block;
      box-sizing: border-box;
      min-width: 0;
      grid-column: var(--ds-col-start-current) / span var(--ds-col-span-current);
    }

    @media (min-width: 640px) {
      :host {
        --ds-col-span-current: var(--ds-col-span-s, var(--ds-col-span, 12));
      }
    }

    @media (min-width: 768px) {
      :host {
        --ds-col-span-current: var(--ds-col-span-m, var(--ds-col-span-s, var(--ds-col-span, 12)));
      }
    }

    @media (min-width: 1024px) {
      :host {
        --ds-col-span-current: var(--ds-col-span-l, var(--ds-col-span-m, var(--ds-col-span-s, var(--ds-col-span, 12))));
      }
    }
  `],
})
export class DsColComponent {
  @HostBinding('style.--ds-col-span')
  private spanStyle = '12';

  @HostBinding('style.--ds-col-span-s')
  private spanSStyle: string | null = null;

  @HostBinding('style.--ds-col-span-m')
  private spanMStyle: string | null = null;

  @HostBinding('style.--ds-col-span-l')
  private spanLStyle: string | null = null;

  @HostBinding('style.--ds-col-start-current')
  private startStyle = 'auto';

  @Input({ transform: numberAttribute })
  set span(value: number) {
    this.spanStyle = String(this.clamp(value || 12));
  }

  @Input({ transform: numberAttribute })
  set spanS(value: number | null) {
    this.spanSStyle = this.optionalSpan(value);
  }

  @Input({ transform: numberAttribute })
  set spanM(value: number | null) {
    this.spanMStyle = this.optionalSpan(value);
  }

  @Input({ transform: numberAttribute })
  set spanL(value: number | null) {
    this.spanLStyle = this.optionalSpan(value);
  }

  @Input({ transform: numberAttribute })
  set start(value: number | null) {
    this.startStyle = value == null || Number.isNaN(value) ? 'auto' : String(this.clamp(value));
  }

  private optionalSpan(value: number | null): string | null {
    return value == null || Number.isNaN(value) ? null : String(this.clamp(value));
  }

  private clamp(value: number): number {
    return Math.min(Math.max(Math.trunc(value), 1), 24);
  }
}
